'use client';

import { useEffect, useState } from 'react';

const DESKTOP_HOVER_QUERY = '(hover: hover) and (pointer: fine)';

export function useIsDesktopHover(): boolean {
  const [isDesktopHover, setIsDesktopHover] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mediaQuery = window.matchMedia(DESKTOP_HOVER_QUERY);
    const handleChange = () => setIsDesktopHover(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isDesktopHover;
}
